/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import PropTypes from 'prop-types';

import {
  DATAITEM_TYPE_EVENT,
  DATAITEM_TYPE_DERIVED_EVENT,
  DATAITEM_TYPE_METRIC,
  DATAITEM_TYPE_DERIVED,
  DATAITEM_TYPE_DIMENSION,
  DATAITEM_TYPE_DERIVED_DIMENSION,
  DATAITEM_TYPE_CALCULATED_METRIC,
  DATAITEM_TYPE_DERIVED_ALERT,
  DEPENDENCY_TYPE_FUNCTION,
  DEPENDENCY_TYPE_GRANULARITY,
} from 'dataConstants';

export const DataItemPropTypes = PropTypes.shape({
  columnName: PropTypes.string,
  columnType: PropTypes.string,
  ddId: PropTypes.string,
  defaultValue: PropTypes.string,
  eventName: PropTypes.string,
  name: PropTypes.string,
  sourceTableName: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  transient: PropTypes.bool,
  type: PropTypes.oneOf([
    DATAITEM_TYPE_CALCULATED_METRIC,
    DATAITEM_TYPE_DERIVED,
    DATAITEM_TYPE_DERIVED_ALERT,
    DATAITEM_TYPE_DERIVED_DIMENSION,
    DATAITEM_TYPE_DERIVED_EVENT,
    DATAITEM_TYPE_DIMENSION,
    DATAITEM_TYPE_EVENT,
    DATAITEM_TYPE_METRIC,
  ]),
  uuid: PropTypes.string,
});

export const DataItemsPropTypes = PropTypes.arrayOf(DataItemPropTypes);

export const DataItemGraphsPropTypes = PropTypes.shape({
  data: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  fetchingData: PropTypes.bool,
  fetchDataError: PropTypes.object, // eslint-disable-line react/forbid-prop-types
});

export const DependenciesPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.oneOf([DEPENDENCY_TYPE_FUNCTION, DEPENDENCY_TYPE_GRANULARITY]),
  })
);

export const DataDependencyPropTypes = PropTypes.shape({
  name: PropTypes.string,
  dependencies: DependenciesPropTypes,
});

/** Object where each data items dependency is keyed by it's name */
export const DataDependenciesPropTypes = PropTypes.objectOf(DataDependencyPropTypes);

export const RecentDatumPropTypes = PropTypes.shape({
  id: PropTypes.string,
  timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

export const RecentDataPropTypes = PropTypes.arrayOf(RecentDatumPropTypes);
